import(/* webpackMode: "eager", webpackExports: ["MenuPage"] */ "/home/runner/work/1/s/src/components/menu/menu.tsx");
